import { Grid, Typography } from "@mui/material";
import CardSys from "../../../../components/cardSys";
import { useContext } from "react";
import { FilterContext } from "../../contexts/FilterContext";
import PrintIcon from "@mui/icons-material/Print";

export default function Header({ children }) {

    const { header } = useContext(FilterContext)
    const link = `/previewPdf`
    return (
        <CardSys>
            <Grid container>
                <Grid item sm={10} xs={10}>
                    <Grid container>
                        {/* <Grid item sx={{ marginLeft: "10px" }} xs={12}>
                            <Grid container spacing={1}>
                                <Grid sx={{}} item xs={8}>
                                </Grid>
                                <Grid sx={{ fontSize: "1rem", fontWeight: "bold" }} item xs={2}>
                                </Grid>
                                <Grid sx={{ fontSize: "1rem", fontWeight: "bold" }} item xs={2}>
                                </Grid>
                            </Grid>
                        </Grid> */}
                        <Grid item xs={12}>
                            <Grid container spacing={2} justifyContent={"space-between"}>
                                <Grid item xs={12} sm={"auto"}>
                                    <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
                                        Nome Fantasia
                                    </Typography>
                                    {header.map((head, index) => (
                                        <Typography key={index} sx={{ fontSize: "0.8rem", color: "#2C4992", textTransform: "capitalize" }}>
                                            {head.nome_fantasia.toUpperCase()}
                                        </Typography>
                                    ))}
                                </Grid>
                                <Grid item xs={12} sm={"auto"}>
                                    <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
                                        CNPJ
                                    </Typography>
                                    {header.map((head, index) => (
                                        <Typography key={index} sx={{ fontSize: "0.8rem", color: "#2C4992", textTransform: "capitalize" }}>
                                            {head.pes_cpfcnpj}
                                        </Typography>
                                    ))}

                                </Grid>
                                <Grid item xs={12} sm={"auto"}>
                                    <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
                                        Início das Atividades
                                    </Typography>
                                    {header.map((head, index) => (
                                        <Typography key={index} sx={{ fontSize: "0.8rem", color: "#2C4992", textTransform: "capitalize" }}>{head.data_inicio}</Typography>
                                    ))}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item sm={2} xs={2}>
                    <Grid sx={{ display: "flex", justifyContent: "end", marginRight: "60px" }}>
                        <a
                            href={link}
                            style={{
                                color: "white",
                                backgroundColor: "#0032A0",
                                width: "40px",
                                height: "40px",
                                padding: "6px 8px",
                                borderRadius: "4px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                            target="_blank" rel="noreferrer"
                        >
                            <PrintIcon sx={{ color: 'white' }} />
                        </a>
                    </Grid>
                </Grid>
            </Grid>
        </CardSys>
    )
}